module.exports = __webpack_public_path__ + "static/media/slide-4.5cc2f3df.png";